// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DQLY","input":"styles_input__1p4Tw"};